import { SxProps, Theme } from "@mui/material";

export const saveBtnStyles: SxProps<Theme> = {
  padding: "10px 32px",
  borderRadius: "10px",
  color: "#FFFFFF",
  fontWeight: 600,
  transition: "background 0.3s",
  alignSelf: "flex-start",
  margin: "15px 10px 10px 0",
  background: "#1FA1E5",

  "&:disabled": {
    background: "#cccccc",
    color: "#666666",
  },
};

export const backButtonStyles: SxProps<Theme> = {
  color: "#bfc9d1",
  fontSize: "17px",
  textAlign: "left",
  alignSelf: "flex-start",
  marginTop: "15px",
  textTransform: "none",
  "&:hover": {
    color: "#1FA1E5",
    background: "none",
  },
};
